import {EditReferringSpecialistValidationSchema} from '@/features/projects/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

interface EditReferringSpecialistFormProviderProps {
    defaultValues: EditReferringSpecialistValidationSchema
    children: ReactNode
}

export const EditReferringSpecialistFormProvider = ({
    defaultValues,
    children
}: EditReferringSpecialistFormProviderProps) => {
    const form = useForm<EditReferringSpecialistValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(EditReferringSpecialistValidationSchema),
        defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
